module.exports = {
  title: 'Radar Chart with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-06-09',
  slug: 'radar-chart',
  tags: ['skia'],
};
